var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEmpty)?_c('div',{ref:"chart",class:_vm.$style.chart}):_c('empty-content')
}
var staticRenderFns = []

export { render, staticRenderFns }